import React from 'react';
import { string } from 'prop-types';

export const Salsify = ({ salsifyRichContent, parentId }) => {

  // Removed title, meta & base tags from the rich content html response
  const htmlRegex = /<(meta|base|title)[^>]*>|(.*?)<\/title>/g;
  const parsedRichContent = salsifyRichContent.replace(htmlRegex, '');
  return (
    <div
      id={parentId}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: parsedRichContent
      }}
    />
  );
};

Salsify.displayName = 'Salsify';

Salsify.propTypes = {
  salsifyRichContent: string.isRequired,
  parentId: string.isRequired
};